// extracted by css-extract-rspack-plugin
export default {"container":"container-Pdimvh","label":"label-h2teMp","selectWrapper":"selectWrapper-Xkceoe","select":"select-YYmFVU","iconContainer":"iconContainer-Gxw9_5","icon":"icon-TclMx5"};